module.exports = __webpack_public_path__ + "static/28import-4e2621cc07ce971a6ed1ca41431deb47.png";